<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page mb-4 text-white">Resource Management</div>
          <lms-button color="#fff" @click="$Bus.$emit('create-asset')"
            >Add Asset</lms-button
          >
          <lms-button
            class="ml-4"
            color="#fff"
            @click="$router.push({ name: 'tenant-create-article' })"
            >Add Article</lms-button
          >
          <lms-button
            class="ml-4"
            color="#fff"
            @click="$router.push({ name: 'tenant-add-quiz' })"
            >Add Quiz</lms-button
          >
          <lms-button
            class="ml-4"
            color="#fff"
            @click="$router.push({ name: 'tenant-add-exercise' })"
            >Add Exercise</lms-button
          >
          <lms-button class="ml-4" color="#fff" @click="openWindow()"
            >Add Gamification</lms-button
          >
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>

    <div v-if="value == 'asset'">
      <div class="flex">
        <page-header
          @click="swap('asset')"
          :class="value == 'asset' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Assets</page-header
        >
        <page-header
          @click="swap('article')"
          :class="value == 'article' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Article</page-header
        >
        <page-header
          @click="swap('quiz')"
          :class="value == 'quiz' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Quiz</page-header
        >
        <page-header
          @click="swap('exercise')"
          :class="value == 'exercise' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Exercise</page-header
        >
      </div>
      <hr class="mx-4" />
      <div class="mx-8 mt-4">
        <linput
          v-model="search"
          class="py-2"
          placeholder="Search by Asset Name"
        />
      </div>
      <div class="flex flex-wrap">
        <div
          class="md:w-1/3 w-full"
          v-for="asset in searchAssets"
          :key="asset.id"
        >
          <asset-card class="m-2" :asset="asset" />
        </div>
      </div>
      <div />
    </div>

    <div v-if="value == 'article'">
      <div class="flex">
        <page-header
          @click="swap('asset')"
          :class="value == 'asset' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Assets</page-header
        >
        <page-header
          @click="swap('article')"
          :class="value == 'article' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Article</page-header
        >
        <page-header
          @click="swap('quiz')"
          :class="value == 'quiz' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Quiz</page-header
        >
        <page-header
          @click="swap('exercise')"
          :class="value == 'exercise' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Exercise</page-header
        >
      </div>
      <hr class="mx-4" />
      <div class="mx-8 mt-4">
        <linput
          v-model="search2"
          class="py-2"
          placeholder="Search by Article Title"
        />
      </div>
      <div class="flex flex-wrap">
        <div
          class="md:w-1/3 w-full"
          v-for="article in searchArticles"
          :key="article.id"
        >
          <article-card class="m-2" :article="article" />
        </div>
      </div>
      <div />
    </div>

    <div v-if="value == 'quiz'">
      <div class="flex">
        <page-header
          @click="swap('asset')"
          :class="value == 'asset' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Assets</page-header
        >
        <page-header
          @click="swap('article')"
          :class="value == 'article' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Article</page-header
        >
        <page-header
          @click="swap('quiz')"
          :class="value == 'quiz' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Quiz</page-header
        >
        <page-header
          @click="swap('exercise')"
          :class="value == 'exercise' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Exercise</page-header
        >
      </div>
      <hr class="mx-4" />
      <div class="mx-8 mt-4">
        <linput
          v-model="search"
          class="py-2"
          placeholder="Search by Quiz Title"
        />
      </div>
      <div class="flex flex-wrap">
        <div class="md:w-1/3 w-full" v-for="quiz in searchQuiz" :key="quiz.id">
          <quiz-card class="m-2" :quiz="quiz" />
        </div>
      </div>
      <div />
    </div>

    <div v-if="value == 'exercise'">
      <div class="flex">
        <page-header
          @click="swap('asset')"
          :class="value == 'asset' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Assets</page-header
        >
        <page-header
          @click="swap('article')"
          :class="value == 'article' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Article</page-header
        >
        <page-header
          @click="swap('quiz')"
          :class="value == 'quiz' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Quiz</page-header
        >
        <page-header
          @click="swap('exercise')"
          :class="value == 'exercise' ? 'active_tab' : ''"
          class="py-2 main-tenant-color cursor-pointer"
          >Exercise</page-header
        >
      </div>
      <hr class="mx-4" />
      <div class="mx-8 mt-4">
        <linput
          v-model="search2"
          class="py-2"
          placeholder="Search by Exercise Title"
        />
      </div>
      <div class="flex flex-wrap">
        <div
          class="md:w-1/3 w-full"
          v-for="exercise in searchExercise"
          :key="exercise.id"
        >
          <exercise-card class="m-2" :exercise="exercise" />
        </div>
      </div>
      <div />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  components: {
    CourseCard: () => import("@/components/tenant/course-card"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    QuizTable: () => import("@/components/tenant/quiz-table"),
    QuizCard: () => import("@/components/tenant/quiz-card"),
    AssetCard: () => import("@/components/tenant/asset-card"),
    ArticleCard: () => import("@/components/tenant/article-card"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
    QuizTable: () => import("@/components/tenant/quiz-table"),
    QuizCard: () => import("@/components/tenant/quiz-card"),
    ExerciseCard: () => import("@/components/tenant/exercise-card"),
  },
  data() {
    return {
      form: {},
      error: {},
      value: "asset",
      search: "",
      search2: "",
      showAssetModal: false,
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions([
      "fetchTenantAssets",
      "loadUserArticles",
      "tenantFetchQuiz",
      "tenantFetchExercise",
    ]),
    swap(val) {
      //console.log({ val });
      this.value = val;
    },

    openWindow() {
      window.open(
        `https://portal.games.edc.hostville.link/api/h5p?tenant_id=${this.getUser.id}`,
        "_blank"
      );
    },
  },
  computed: {
    ...mapGetters([
      "getQuizzes",
      "getExercises",
      "getTenantAsset",
      "getTenantArticle",
      "getUser",
    ]),
    searchAssets() {
      return this.getTenantAsset.filter((asset) => {
        return asset.asset_name.toLowerCase().match(this.search.toLowerCase());
      });
    },
    searchArticles() {
      let articlesArray = this.getTenantArticle.filter((article) => {
        return article.title.toLowerCase().match(this.search2.toLowerCase());
      });
      return articlesArray.sort((a, b) => a.title < b.title);
    },
    searchQuiz() {
      return this.getQuizzes.filter((quiz) => {
        return quiz.title.toLowerCase().match(this.search.toLowerCase());
      });
    },
    searchExercise() {
      return this.getExercises.filter((exercise) => {
        return exercise.title.toLowerCase().match(this.search2.toLowerCase());
      });
    },
  },
  mounted() {
    this.updateLoader(true);
    this.fetchTenantAssets();
    this.loadUserArticles();
    this.tenantFetchQuiz();
    this.tenantFetchExercise();
    this.updateLoader(false);
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/main.scss";
.active_tab {
  border-bottom: 2px solid color(lms-tenant);
  color: color(lms-tenant);
}
</style>
